module.exports = __webpack_public_path__ + "img/about-辅导项目-初级职称（士）类.db2ebc7d.jpg";